import type { ExtendedRouteObject } from '#/routes/types';
import loader, { id, type LoaderData, type Params } from './loader';

export default {
  id,
  path: '/aarsopgoerelser',
  loader,
  lazy: {
    Component: async () => (await import('./index')).default,
  },
  handle: () => ({
    breadcrumb: { label: 'Årsrapporter' },
  }),
} as const satisfies ExtendedRouteObject<Params, LoaderData>;
